module.exports = __webpack_public_path__ + "images/psp/College/5x5.svg";